<template>
  <section class="hover-section">
    <div class="title-container" :style="titleContainerStyles">
      <h2 ref="principal-title" class="title" :style="principalTitleStyles">
        {{ $t(contentTitle) }}
      </h2>
      <h2
        v-for="(item, index) in contentItems"
        :key="index"
        :ref="'title' + index"
        class="description-hover hide"
        :style="hoverTitleStyles"
      >
        {{ $t(item.description) }}
      </h2>
    </div>
    <!-- eslint-disable max-len -->
    <div
      class="
        d-flex
        align-items-center
        justify-content-center
        flex-wrap
        align-items-stretch
        flex-content
      "
      :style="boxHoverColors"
    >
      <component
        :is="externalLink(item) ? 'a' : redirectToLink(item) ? 'nuxt-link' : 'div'"
        v-for="(item, index) in contentItems"
        :key="index"
        :to="redirectToLink(item)"
        :href="externalLink(item)"
      >
        <div
          class="flex-item"
          :class="{ effect: effectBox }"
          :style="boxStyles"
          :data-title="'title' + index"
          @mouseout="outTitle($event, index)"
          @mouseover="hoverTitle($event, index)"
        >
          <Icon :width="35" :height="35" :color="iconColor" :icon="item.icon" :style="iconStyle" />
          <h3 class="description" :style="textBoxStyles">
            {{ $t(item.title) }}
          </h3>
        </div>
      </component>
    </div>
  </section>
</template>

<script>
import Icon from 'UI/Icon';
export default {
  name: 'HoverSection',
  components: { Icon },
  props: {
    contentTitle: {
      type: String,
      required: true
    },
    contentItems: {
      type: Array,
      required: true
    },
    boxWidth: {
      type: Number,
      required: false,
      default: 100
    },
    boxWidthMinContent: {
      type: Boolean,
      required: false,
      default: false
    },
    titleFontColor: {
      type: String,
      required: false,
      default: '#212529'
    },
    boxFontColor: {
      type: String,
      required: false,
      default: '#212529'
    },
    boxHoverBackgroundColor: {
      type: String,
      required: false,
      default: 'whitesmoke'
    },
    boxTextFontColor: {
      type: String,
      required: false,
      default: ''
    },
    boxTextHoverFontColor: {
      type: String,
      required: false,
      default: ''
    },
    boxHoverFontColor: {
      type: String,
      required: false,
      default: '#000000'
    },
    iconSize: {
      type: Number,
      required: false,
      default: 35
    },
    effectBox: {
      type: Boolean,
      required: false,
      default: false
    },
    marginRightBox: {
      type: Number,
      required: false,
      default: 0
    },
    titleContainerHeight: {
      type: Number,
      required: false,
      default: 250
    },
    iconDescriptionFontWeight: {
      type: Number,
      required: false,
      default: 500
    }
  },
  computed: {
    titleContainerStyles() {
      return `height: ${this.titleContainerHeight}px`;
    },
    boxStyles() {
      return `
        width: ${this.boxWidthMinContent ? 'min-content;' : this.boxWidth + 'px;'}
        color: ${this.boxFontColor};
        margin-right: ${this.marginRightBox}px;
        `;
    },
    principalTitleStyles() {
      return 'color: ' + this.titleFontColor + ';';
    },
    hoverTitleStyles() {
      return 'color: ' + this.titleFontColor + ';';
    },
    textBoxStyles() {
      return `
      ${this.boxTextFontColor !== '' ? 'color: ' + this.boxTextFontColor + ';' : ''}
      font-weight: ${this.iconDescriptionFontWeight};
      `;
    },
    iconStyle() {
      return 'font-size: ' + this.iconSize + 'px;';
    },
    boxHoverColors() {
      return `
        --hover-bg-color-box: ${this.boxHoverBackgroundColor};
        --hover-box-font-color:  ${this.boxHoverFontColor};
        --hover-box-text-color: ${this.boxTextHoverFontColor};
      `;
    },
    iconColor() {
      return this.boxFontColor ? this.boxFontColor : 'black';
    }
  },
  methods: {
    hoverTitle(e, index) {
      const ref = 'title' + index;
      let principal_title = this.$refs['principal-title'];
      principal_title.classList.add('hide');

      let title = this.$refs[ref][0];
      title.classList.remove('hide');
    },
    outTitle(e, index) {
      const ref = 'title' + index;
      let principal_title = this.$refs['principal-title'];
      principal_title.classList.remove('hide');

      let title = this.$refs[ref][0];
      title.classList.add('hide');
    },
    externalLink(item) {
      return item.externalLink;
    },
    redirectToLink(item) {
      return (item.linkLoggedIn && this.$auth.loggedIn ? item.linkLoggedIn : item.link) || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.hover-section > .title-container {
  width: auto;
  margin-top: 95px;
  margin-bottom: 0px;
  height: 150px;
  display: flex;
  align-items: center;
}
.hover-section > .title-container > .description-hover {
  font-size: 50px;
  font-weight: 400;
  line-height: 53px;
  @media screen and (max-width: 1200px) {
    font-size: 40px;
  }
}
.hover-section > .title-container > .title {
  font-size: 65px;
  font-weight: 500;
  @include xl {
    font-size: 50px;
  }
  @include lg {
    font-size: 40px !important;
  }
  @include md {
    font-size: 30px !important;
  }
  @include sm {
    font-size: 25px !important;
  }
}
.flex-content {
  max-width: 100%;
  width: fit-content;
  width: -moz-fit-content;
}
.flex-content .flex-item {
  margin-right: 0;
  padding: 10px 8px;
  min-width: 100px;
  border-radius: 8px;
  cursor: pointer;
  width: 100px;
  transform: translateY(0);
  transition: transform 0.5s;
}
.flex-content .flex-item:hover {
  background-color: var(--hover-bg-color-box);
  color: var(--hover-box-font-color) !important;
  font-weight: 500;
  -webkit-box-shadow: 0px 0px 7px 0px rgba(191, 191, 191, 1);
  -moz-box-shadow: 0px 0px 7px 0px rgba(191, 191, 191, 1);
  box-shadow: 0px 0px 7px 0px rgba(191, 191, 191, 1);
}
.flex-content .flex-item.effect:hover {
  transform: translateY(-14px);
  padding-bottom: 14px;
  transition: transform 0.5s;
}
.flex-content .flex-item:hover > .description {
  color: var(--hover-box-text-color) !important;
}
.flex-content .flex-item > .description {
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}
.flex-content .flex-item > span[class^='icon-'] {
  font-size: 35px;
  display: block;
}
</style>
